module.exports = __webpack_public_path__ + "img/text_record_05.05aa3637.png";